import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Highlight } from 'react-instantsearch/dom';
import classnames from 'classnames';

const Show = ({ hit, onSelect, className, onMouseEnter }) => (
  <Link
    id={`show-${hit.id}`}
    to={`/show/${hit.id}`}
    onClick={onSelect}
    onMouseEnter={onMouseEnter}
    className={classnames(
      'tvt-header__search-bar-results__result-item',
      className
    )}
  >
    <p>
      <Highlight className="search-result-text" attribute="name" hit={hit} /> in{' '}
      <span className="search-result-text--accent">Shows</span>
    </p>
  </Link>
);

Show.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object
  ]),
  hit: PropTypes.shape({}).isRequired,
  onSelect: PropTypes.func.isRequired,
  onMouseEnter: PropTypes.func
};

Show.defaultProps = {
  className: '',
  onMouseEnter: () => {}
};

export default Show;
